import { Button, SectionAlert, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { SpinnerButton } from '@app/components/SpinnerButton';

import Footer from '../Footer';
import ReviewContactInformation from './ReviewContactInformation';
import ReviewPlans from './ReviewPlans';

import styles from './index.module.scss';

const LeftSection = ({
  handleCancel,
  handleContinue,
  isRemoveViasatLoading,
  showEquipmentAlert,
}: {
  handleCancel: () => void;
  handleContinue: () => void;
  isRemoveViasatLoading: boolean;
  showEquipmentAlert: boolean;
}) => {
  const { t } = useTranslation(['Disconnect', 'Global']);

  return (
    <>
      <Surface variant="primary" radius="16px" className={styles['leftCardContent']}>
        <div>
          <Txt mb="8px" variant="bodyLargeBold">
            {t('step3.leftTitle1')}
          </Txt>
          <Txt variant="bodySmallRegular">{t('step3.leftText1')}</Txt>
        </div>
        <hr className={styles['separator']} />
        <ReviewContactInformation />
        {showEquipmentAlert && (
          <SectionAlert className={styles['sectionAlert']}>
            <div>
              <Txt component="span" variant="smallBold" color="regular">
                {t('contactInfo.notice')}
              </Txt>
              <Txt component="span" variant="smallRegular" color="regular">
                {t('contactInfo.alert')}
              </Txt>
            </div>
          </SectionAlert>
        )}
        <div>
          <Txt mb="8px" variant="bodyLargeBold">
            {t('step3.plans.headlineTitle')}
          </Txt>
          <Txt variant="bodySmallRegular">{t('step3.plans.headlineText')}</Txt>
        </div>
        <hr className={styles['separator']} />
        <ReviewPlans />
      </Surface>
      <Footer>
        <Button variant="tertiary" onClick={handleCancel}>
          {t('button.cancel')}
        </Button>

        <SpinnerButton
          loading={isRemoveViasatLoading}
          handleClick={handleContinue}
          label={t('step3.primaryCTA')}
          variant="destructive"
          disabled={isRemoveViasatLoading}
        />
      </Footer>
    </>
  );
};

export default LeftSection;
